import { getUser } from "lib/user-session"
import { getPrimaryUserRole } from "data/user"
import { useAsync } from "react-use"

export default function usePrimaryUserRole(user = getUser()) {
  const { value: role, loading } = useAsync(() => getPrimaryUserRole(user), [user])
  return [role, loading]
}
